import BaseStyle from 'primevue/base/style';

var classes = {
  root: 'p-avatar-group p-component'
};
var AvatarGroupStyle = BaseStyle.extend({
  name: 'avatargroup',
  classes: classes
});

export { AvatarGroupStyle as default };
